import { render, staticRenderFns } from "./EmployerLetterView.vue?vue&type=template&id=0a4dde3d&"
import script from "./EmployerLetterView.vue?vue&type=script&lang=js&"
export * from "./EmployerLetterView.vue?vue&type=script&lang=js&"
import style0 from "./EmployerLetterView.vue?vue&type=style&index=0&id=0a4dde3d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports